module.exports = __webpack_public_path__ + "img/messageIcon.2add8088.svg";